import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { selectProjectResults } from '../../project-details/data-access/project.reducer';
import PromptInjectionChart from './PromptInjectionChart';

// Define the interface for fairness data
export interface ComplianceAnalysis {
  'Internal Violations': number;
  'External Violations': number;
}

export interface SecurityFindings {
  'Adversarial Patterns': number;
  'Model Override Attempts': number;
}

export const PromptInjectionCard = () => {
  const projectResults = useSelector(selectProjectResults); // Fetch from Redux Store

  const [promptData, setPromptData] = useState<ComplianceAnalysis | null>(null);
  const [securityFindings, setSecurityFindings] =
    useState<SecurityFindings | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    console.log('projectResults', projectResults);
    if (projectResults?.results?.prompt_validation) {
      const analysis =
        projectResults.results.prompt_validation[
          'Prompt Compliance Analysis'
        ] || null;
      const securityFindings =
        projectResults.results.prompt_validation['Security Findings'] || null;
      setPromptData(analysis);
      setSecurityFindings(securityFindings);
      setIsLoading(false); // Hide loading indicator after setting data
    }
  }, [projectResults]);

  const chartData = promptData
    ? [
        {
          name: 'Internal Violations',
          value: promptData['Internal Violations']
        },
        {
          name: 'External Violations',
          value: promptData['External Violations']
        }
      ]
    : [];

  const securityFindingsChartData = securityFindings
    ? [
        {
          name: 'Adversarial Patterns',
          value: securityFindings['Adversarial Patterns']
            .toString()
            .toLowerCase()
            .includes('no')
            ? 0
            : 1
        },
        {
          name: 'Model Override Attempts',
          value: securityFindings['Model Override Attempts']
            .toString()
            .toLowerCase()
            .includes('no')
            ? 0
            : 1
        }
      ]
    : [];
  console.log('PROMPT INJECTION LOADING', isLoading);
  return (
    <>
      {isLoading ? (
        <Backdrop
          sx={theme => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
          open={isLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      ) : (
        <Row className="g-3 mt-4">
          <Col xs={12} md={6}>
            {chartData && (
              <PromptInjectionChart
                description={
                  'Identifies and quantifies bias in ML models and LLM outputs by analyzing sensitive attributes.'
                }
                title={'Prompt Validation - Compliance Analysis'}
                data={chartData}
              />
            )}
          </Col>
          <Col xs={12} md={6}>
            {securityFindingsChartData && (
              <PromptInjectionChart
                description={
                  'Identifies and quantifies bias in ML models and LLM outputs by analyzing sensitive attributes.'
                }
                title={'Prompt Validation - Security Findings'}
                data={securityFindingsChartData}
              />
            )}
          </Col>
        </Row>
      )}
    </>
  );
};
